import Vue from 'vue';
import _ from 'lodash';

import App from './App.vue';
import router from './router';
import store from './store';

import './registerServiceWorker';

Object.defineProperty(Vue.prototype, '_', { value: _ });

Vue.mixin({
  methods: {
    sec2time: (timeInSeconds) => {
      const pad = (num, size) => (`000${num}`).slice(size * -1);
      const time = parseFloat(timeInSeconds).toFixed(3);
      const minutes = Math.floor(time / 60) % 60;
      const seconds = Math.floor(time - minutes * 60);
      let paddef = 1;
      if (timeInSeconds > 600) paddef = 2;
      return `${pad(minutes, paddef)}:${pad(seconds, 2)}`;
    },
  },
});

Vue.config.devtools = true;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
